// @flow

/* eslint-disable max-len,react/jsx-tag-spacing */
import * as React from 'react';
import classNames from 'classnames';
// import { Responsive } from '../Responsive';
import * as css from './Icon.scss';

type Props = {|
	type: string,
	className?: string,
	width?: number,
	height?: number,
	color?: string,
|};

/**
 * @link - https://material.io/tools/icons/?style=baseline
 * @return {XML}
 */
const Icon = ({ type, className, width, height, color, ...iconProps }: Props) => {
	let icon = null;
	const svgProps = {
		width,
		height,
		viewBox: `0 0 ${width || 24} ${height || 24}`,
		xmlns: 'http://www.w3.org/2000/svg',
	};
	// const isDesktop = Responsive.isMatching(Responsive.DESKTOP);

	switch (type) {
		case 'whatsapp':
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<circle fill="#313131" cx="16" cy="16" r="16" />
						<path d="M6 6h20v20H6z" />
						<path
							d="m8.5 23.5 1.375-3.167a7.5 7.5 0 1 1 2.833 2.417L8.5 23.5"
							stroke="#FFF"
							strokeWidth="1.8"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M13.5 14.333a.417.417 0 1 0 .833 0V13.5a.417.417 0 1 0-.833 0v.833a4.167 4.167 0 0 0 4.167 4.167h.833a.417.417 0 0 0 0-.833h-.833a.417.417 0 1 0 0 .833"
							stroke="#FFF"
							strokeWidth="1.25"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
				</svg>
			);
			break;
		case 'facebook':
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<circle fill="#313131" cx="16" cy="16" r="16" />
						<path d="M6 6h20v20H6z" />
						<path
							d="M11.833 18.667h2.5V25.5h3.334v-6.833h2.5L21 15.333h-3.333v-2.666c0-.46.373-.834.833-.834H21V8.5h-2.5a4.167 4.167 0 0 0-4.167 4.167v2.666h-2.5v3.334z"
							stroke="#FFF"
							strokeWidth=".5"
							fill="#FFF"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</g>
				</svg>
			);
			break;
		case 'ynet-logo':
			icon = (
				<svg {...svgProps}>
					<defs>
						<path
							d="M0 19c0 10.494 8.506 19 19 19 10.493 0 19-8.506 19-19S29.493 0 19 0C8.506 0 0 8.506 0 19z"
							id="uqt0onkaca"
						/>
					</defs>
					<g fill="none" fillRule="evenodd">
						<path
							d="M59 29.965V13.88C59 10.352 56.78 8 53.312 8c-2.404 0-4.347.94-6.289 3.246l-.462-2.117c-.14-.564-.463-.847-1.11-.847h-1.387c-.555 0-1.064.377-1.064.988v20.695c0 .565.509 1.035 1.064 1.035h2.127c.555 0 1.017-.47 1.017-1.035V17.22c0-3.152 2.173-5.55 4.948-5.55 1.896 0 2.636.94 2.636 3.151v15.145c0 .565.508 1.035 1.064 1.035h2.127c.555 0 1.017-.47 1.017-1.035M66.425 17.405c.465-4.842 2.608-6.006 4.285-6.006 2.887 0 3.865 3.026 3.959 6.006h-8.244zM79 19.547C79 11.027 75.274 8 70.57 8 65.4 8 62 12.423 62 19.407 62 27.042 65.586 31 71.92 31c2.749 0 4.332-.42 5.776-1.07.559-.234.792-.7.605-1.258l-.512-1.49c-.186-.512-.559-.885-1.258-.652-1.35.42-2.608.792-4.377.792-4.1 0-5.543-2.421-5.73-6.751h11.551c.56 0 1.025-.466 1.025-1.024zM90.974 29.437l-.232-1.425c-.093-.551-.557-.827-1.067-.735-.418.092-1.068.184-1.44.184-1.067 0-1.577-.552-1.577-1.793V11.833h2.645c.557 0 .975-.46.975-1.011V9.58c0-.552-.418-1.012-.975-1.012h-2.645V2.78c0-.828-.604-.874-1.3-.69l-2.088.597c-.51.138-.79.598-.79 1.195v4.688h-2.505c-.604 0-.975.46-.975 1.012v1.24c0 .552.371 1.012.975 1.012h2.506v14.525c0 3.08 1.531 4.642 4.826 4.642 1.114 0 2.228-.138 2.97-.368.65-.184.79-.643.697-1.195"
							fill="#000"
						/>
						<path d="M0 19C0 8.506 8.506 0 19 0s19 8.506 19 19-8.506 19-19 19S0 29.494 0 19" fill="red" />
						<g>
							<mask id="70rqr899xb" fill="#fff">
								<use xlinkHref="#uqt0onkaca" />
							</mask>
							<path
								d="M27.038 8.348c.153-.614-.192-.998-.69-.998h-2.303c-.5 0-.921.269-1.036.806l-2.84 11.588c-.268 1.074-.46 2.034-.614 2.724a11.884 11.884 0 0 0-.345-2.34L15.987 8.194c-.154-.537-.537-.844-1.075-.844H12.38c-.499 0-.882.384-.69.96l4.91 15.386c.193.576.461.806 1.037.806h1.304c-.076.384-.46 2.072-.652 2.302-.46 1.612-1.266 2.725-2.61 3.415l-.536.269c-.422.23-.691.767-.46 1.19l.805 1.573c.23.46.73.613 1.151.422l.844-.384c2.034-.921 3.53-2.686 4.298-5.526l5.257-19.415z"
								fill="#FFF"
								mask="url(#70rqr899xb)"
							/>
						</g>
					</g>
				</svg>
			);
			break;

		case 'share':
			icon = (
				<svg {...svgProps}>
					<g>
						<rect data-name="Rectangle 299" width={width} height={height} rx="17.5" fill="#000" />
						<g data-name="Group 366">
							<g data-name="Group 365">
								<g data-name="Group 364">
									<path
										data-name="Path 1246"
										d="M5.8 6.858a2.977 2.977 0 0 1 0 1.667l5.471 2.9a2.358 2.358 0 1 1-.554 1.046l-5.471-2.9a2.958 2.958 0 1 1 0-3.758l5.471-2.9a2.368 2.368 0 1 1 .554 1.046z"
										fill="#fff"
										transform="translate(8.875 10.057)"
									/>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case 'accessibility':
			icon = (
				<svg {...svgProps} viewBox="0 0 32 32">
					<path
						d="m16,4c-6.62,0-12,5.38-12,12s5.38,12,12,12,12-5.38,12-12-5.38-12-12-12Zm0,22c-5.51,0-10-4.49-10-10s4.49-10,10-10,10,4.49,10,10-4.49,10-10,10Z"
						style={{ fill: '#fff' }}
					/>
					<path
						d="M16 11.5c.85 0 1.55-.7 1.55-1.55s-.7-1.55-1.55-1.55-1.55.7-1.55 1.55.7 1.55 1.55 1.55zM20.8 11.82l-.71.14c-2.71.54-5.46.54-8.18 0l-.71-.14c-.54-.11-1.07.24-1.18.78-.11.54.24 1.07.78 1.18l.71.14c1.16.23 2.32.35 3.48.4v2.54l-2.89 5.69c-.25.49-.05 1.09.44 1.34.49.25 1.09.05 1.34-.44l2.11-4.15 2.11 4.15c.18.35.53.55.89.55.15 0 .31-.03.45-.11.49-.25.69-.85.44-1.34l-2.89-5.69v-2.54c1.16-.05 2.33-.17 3.48-.4l.71-.14c.54-.11.89-.64.78-1.18-.11-.54-.64-.89-1.18-.78z"
						style={{ fill: '#fff' }}
					/>
				</svg>
			);
			break;
		case 'candle':
			icon = (
				<svg width="32" height="39" viewBox="0 0 32 39" fill="none">
					<path
						d="M14.6282 23.3944C14.6282 24.1521 15.2424 24.7662 16 24.7662C16.7576 24.7662 17.3718 24.1521 17.3718 23.3944H14.6282ZM17.3718 18.3434C17.3718 17.5857 16.7576 16.9716 16 16.9716C15.2424 16.9716 14.6282 17.5857 14.6282 18.3434H17.3718ZM16.01 20.8689V22.2407C16.5643 22.2407 17.0642 21.907 17.2768 21.3951C17.4895 20.8831 17.3731 20.2935 16.9818 19.9007L16.01 20.8689ZM16.9634 2L18.324 1.8253C18.2575 1.30722 17.9025 0.871871 17.4085 0.702403C16.9144 0.532935 16.3669 0.658757 15.9964 1.02694L16.9634 2ZM16.009 20.8689L15.0989 19.8425C14.6726 20.2206 14.5243 20.8229 14.7265 21.3556C14.9287 21.8884 15.4392 22.2407 16.009 22.2407V20.8689ZM28.3462 23.6013C28.3462 23.238 28.5497 23.0688 28.5182 23.0974C28.4903 23.1227 28.3708 23.2115 28.0892 23.335C27.5359 23.5776 26.65 23.8286 25.45 24.0511C23.0725 24.492 19.7306 24.7731 16 24.7731V27.5167C19.8456 27.5167 23.3628 27.2285 25.9502 26.7487C27.2327 26.5109 28.3558 26.2138 29.1908 25.8478C29.6034 25.6669 30.0229 25.4363 30.3605 25.1304C30.6944 24.8279 31.0898 24.3157 31.0898 23.6013H28.3462ZM16 24.7731C12.2693 24.7731 8.9275 24.492 6.54995 24.0511C5.34992 23.8286 4.46408 23.5776 3.91074 23.335C3.62914 23.2115 3.50967 23.1227 3.48176 23.0974C3.45022 23.0688 3.65373 23.238 3.65373 23.6013H0.910116C0.910116 24.3157 1.30555 24.8279 1.63949 25.1304C1.97705 25.4363 2.3966 25.6669 2.80917 25.8478C3.64417 26.2138 4.7673 26.5109 6.04974 26.7487C8.63715 27.2285 12.1544 27.5167 16 27.5167V24.7731ZM3.65373 23.6013C3.65373 23.9645 3.45022 24.1338 3.48176 24.1052C3.50967 24.0799 3.62914 23.991 3.91074 23.8675C4.46408 23.625 5.34992 23.3739 6.54995 23.1514C8.9275 22.7106 12.2693 22.4294 16 22.4294V19.6858C12.1544 19.6858 8.63715 19.974 6.04974 20.4538C4.7673 20.6916 3.64417 20.9887 2.80917 21.3548C2.3966 21.5356 1.97705 21.7662 1.63949 22.0721C1.30555 22.3747 0.910116 22.8868 0.910116 23.6013H3.65373ZM16 22.4294C19.7306 22.4294 23.0725 22.7106 25.45 23.1514C26.65 23.3739 27.5359 23.625 28.0892 23.8675C28.3708 23.991 28.4903 24.0799 28.5182 24.1052C28.5497 24.1338 28.3462 23.9645 28.3462 23.6013H31.0898C31.0898 22.8868 30.6944 22.3747 30.3605 22.0721C30.0229 21.7662 29.6034 21.5356 29.1908 21.3548C28.3558 20.9887 27.2327 20.6916 25.9502 20.4538C23.3628 19.974 19.8456 19.6858 16 19.6858V22.4294ZM0.910116 23.6013V34.4563H3.65373V23.6013H0.910116ZM0.910116 34.4563C0.910116 35.1707 1.3054 35.6828 1.63938 35.9855C1.97694 36.2915 2.39651 36.5221 2.80908 36.7029C3.64409 37.069 4.76722 37.3662 6.04964 37.6039C8.63702 38.0837 12.1542 38.3718 16 38.3718V35.6282C12.2691 35.6282 8.92731 35.3471 6.54981 34.9063C5.3498 34.6838 4.46402 34.4328 3.91074 34.1902C3.62917 34.0668 3.50974 33.9779 3.48185 33.9526C3.45036 33.9241 3.65373 34.0933 3.65373 34.4563H0.910116ZM16 38.3718C19.8457 38.3718 23.3629 38.0837 25.9503 37.6039C27.2327 37.3662 28.3559 37.069 29.1909 36.7029C29.6034 36.5221 30.023 36.2915 30.3606 35.9855C30.6946 35.6828 31.0898 35.1707 31.0898 34.4563H28.3462C28.3462 34.0933 28.5496 33.9241 28.5181 33.9526C28.4902 33.9779 28.3708 34.0668 28.0892 34.1902C27.5359 34.4328 26.6502 34.6838 25.4501 34.9063C23.0726 35.3471 19.7308 35.6282 16 35.6282V38.3718ZM31.0898 34.4563V23.6013H28.3462V34.4563H31.0898ZM17.3718 23.3944V18.3434H14.6282V23.3944H17.3718ZM16.01 20.8689C16.9818 19.9007 16.9822 19.9011 16.9825 19.9014C16.9826 19.9015 16.9829 19.9018 16.9831 19.902C16.9835 19.9024 16.9838 19.9027 16.984 19.903C16.9846 19.9035 16.9849 19.9038 16.985 19.9039C16.9852 19.9042 16.9846 19.9035 16.9832 19.9021C16.9803 19.8992 16.9743 19.8929 16.9652 19.8834C16.9471 19.8642 16.917 19.832 16.8766 19.7871C16.7957 19.6971 16.6741 19.5567 16.5251 19.3693C16.2264 18.9937 15.8218 18.4342 15.416 17.7178C14.6016 16.2801 13.8066 14.2549 13.8066 11.8354H11.063C11.063 14.8607 12.0557 17.3523 13.0288 19.0701C13.5168 19.9315 14.0059 20.6094 14.3776 21.0769C14.5638 21.311 14.7214 21.4935 14.8361 21.6211C14.8934 21.6849 14.9401 21.7351 14.9744 21.7712C14.9915 21.7892 15.0055 21.8038 15.0162 21.8148C15.0216 21.8203 15.0261 21.8249 15.0297 21.8286C15.0316 21.8305 15.0332 21.8321 15.0346 21.8335C15.0353 21.8342 15.0359 21.8349 15.0365 21.8355C15.0368 21.8358 15.0372 21.8362 15.0373 21.8363C15.0377 21.8367 15.0381 21.8371 16.01 20.8689ZM13.8066 11.8354C13.8066 6.98915 16.5104 4.38405 17.9303 2.97306L15.9964 1.02694C14.5261 2.48801 11.063 5.79215 11.063 11.8354H13.8066ZM15.6027 2.1747C15.8568 4.15318 16.7026 6.01663 17.347 7.72138C18.0158 9.49076 18.5843 11.3299 18.5843 13.6225H21.3279C21.3279 10.8423 20.6273 8.64005 19.9134 6.75131C19.175 4.79795 18.5245 3.38655 18.324 1.8253L15.6027 2.1747ZM18.5843 13.6225C18.5843 15.0521 17.8097 16.5688 16.877 17.8385C16.427 18.4511 15.9746 18.9599 15.6347 19.315C15.4655 19.4918 15.3261 19.6285 15.2315 19.7189C15.1842 19.764 15.1483 19.7974 15.1255 19.8183C15.1141 19.8287 15.1061 19.836 15.1016 19.8401C15.0993 19.8421 15.0979 19.8434 15.0975 19.8438C15.0973 19.844 15.0973 19.844 15.0975 19.8437C15.0976 19.8436 15.0978 19.8435 15.098 19.8433C15.0982 19.8432 15.0984 19.843 15.0984 19.8429C15.0987 19.8427 15.0989 19.8425 16.009 20.8689C16.9192 21.8953 16.9194 21.8951 16.9197 21.8948C16.9199 21.8947 16.9202 21.8944 16.9204 21.8942C16.9209 21.8938 16.9214 21.8933 16.922 21.8928C16.9232 21.8917 16.9247 21.8904 16.9263 21.8889C16.9297 21.8859 16.934 21.8821 16.9392 21.8774C16.9496 21.868 16.9637 21.8552 16.9813 21.8391C17.0163 21.8069 17.0652 21.7614 17.1258 21.7035C17.247 21.5878 17.416 21.4219 17.6168 21.212C18.0171 20.7938 18.5513 20.1935 19.0881 19.4628C20.1289 18.046 21.3279 15.9395 21.3279 13.6225H18.5843ZM16.009 22.2407H16.01V19.4971H16.009V22.2407Z"
						fill="white"
					/>
				</svg>
			);
			break;
		case 'arrow-left-red':
			icon = (
				<svg width="30" height="30" viewBox="0 0 30 30" fill="none">
					<path
						d="M7.17188 16.875L17.6719 27.375L15 30L0 15L15 0L17.6719 2.625L7.17188 13.125L30 13.125L30 16.875L7.17188 16.875Z"
						fill="#DD1A1A"
					/>
				</svg>
			);
			break;
		case 'arrow-left':
			icon = (
				<svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
					<path
						d="M5.86914 13.3884L13.6469 21.1662L11.6677 23.1106L0.556641 11.9995L11.6677 0.888428L13.6469 2.83287L5.86914 10.6106L22.7789 10.6106V13.3884L5.86914 13.3884Z"
						fill="white"
					/>
				</svg>
			);
			break;
		default:
			break;
	}

	return (
		<i className={classNames(css.icon, className)} {...iconProps}>
			{icon}
		</i>
	);
};

Icon.defaultProps = {
	className: '',
	width: 24,
	height: 24,
	color: '#111',
};

export { Icon };
